/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useEffect } from '@wordpress/element';
import {
	InnerBlocks,
} from '@wordpress/block-editor';
import { compose } from '@wordpress/compose';
import { withDispatch, select } from '@wordpress/data';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import './hooks/addClass';

const ALLOWED_BLOCKS = [ 'gutenify/buttons' ];

const getInnerBlockTemplate = ( ) => {
	return [
		[ 'gutenify/icon', {
			contentJustification: 'center',
		},
		],
		[ 'core/heading', {
			content: 'Info box',
			level: 3,
			textAlign: 'center',
			className: 'gutenify-admin-info-box-block-title',
		},
		],
		[ 'core/heading', {
			textAlign: 'center',
			level: 4,
			// style: { typography: { textTransform: 'capitalize', fontStyle: 'normal', fontWeight: '400' } },
			content: 'Info box subtitle',
			className: 'gutenify-admin-info-box-block-subtitle',
		},
		],
		[ 'core/paragraph', {
			content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed sit amet est massa. Sed enim massa, mattis at libero nec, bibendum ultricies augue.',
			align: 'center',
			className: 'gutenify-admin-info-box-block-content',
		},
		],
		[ 'gutenify/buttons', {
			layout: { type: 'flex', justifyContent: 'center' },
			contentJustification: 'center',
		},
		],
	];
};

const Edit = ( props ) => {
	const { attributes, isSelected, className } = props;
	const { layout, blockClientId } = attributes;
	return (
		<div className={ classnames( className, `gutenify-info-box-${ layout }`, `gutenify-section-${ blockClientId }` ) }>
			{ isSelected && <Inspector { ...props } /> }
			<InnerBlocks
				allowedBlocks={ ALLOWED_BLOCKS }
				template={ getInnerBlockTemplate() }
				templateLock="all"
				templateInsertUpdatesSelection={ false }
				// __experimentalCaptureToolbars={ true }
			/>
		</div>
	);
};

export default compose( [
	withDispatch( ( dispatch, props ) => {
		const { clientId } = props;

		return {
			updateInnerBlocks( template ) {
				const children = select( 'core/block-editor' ).getBlocksByClientId( clientId )[ 0 ].innerBlocks;
				children.forEach( function( child ) {
					if ( 'gutenify/icon' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { contentJustification: template.iconAlign } );
					}
					if ( 'core/heading' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { textAlign: template.titleAlign } );
					}
					if ( 'core/paragraph' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { align: template.titleAlign } );
					}
					if ( 'gutenify/buttons' === child.name ) {
						dispatch( 'core/block-editor' ).updateBlockAttributes( child.clientId, { contentJustification: template.buttonAlign } );
					}
				} );
			},
		};
	} ),
] )( Edit );
